import { Record } from 'immutable'
import { IAdminMSTeamsWelcome } from 'store/entities/adminMSTeamsWelcome/interface'

export const AdminMSTeamsWelcomeRecord = Record<IAdminMSTeamsWelcome>({
  organizationId: null,
  videoId: null,
  videoThumbnail: null,
  title: null,
  bodyText: null,
  buttonText: null,
})

export class AdminMSTeamsWelcome extends AdminMSTeamsWelcomeRecord {}
